import { CloseIcon, clubbiStyled } from 'clubbi-ui'

export const StyledMain = clubbiStyled('div')<{ isModalOpen: boolean }>(
  ({ theme, isModalOpen }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: isModalOpen ? 0 : '6px',
    margin: isModalOpen ? 0 : '6px 0',
  })
)

export const StyledContainer = clubbiStyled('div')<{ isModalOpen: boolean }>(
  ({ theme, isModalOpen }) => ({
    width: isModalOpen ? '100%' : '95%',
    padding: '23px',
    borderRadius: '8px',
    background: 'linear-gradient(225deg, #E50077 0%, #7C00F4 100%)',
    color: theme.palette.brandWhite.main,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  })
)

export const StyledTitle = clubbiStyled('h2')(({ theme }) => ({
  fontSize: 'theme.typography.fontSizeXL',
  fontWeight: '700',
  marginBottom: '8px',
  color: theme.palette.brandWhite.main,
  textAlign: 'center',
  margin: 0,
}))

export const StyledDescription = clubbiStyled('p')(({ theme }) => ({
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '100%',
  margin: '10px 0',
  color: theme.palette.brandWhite.main,
  textAlign: 'center',
}))

export const StyledIcon = clubbiStyled('img')(({ theme }) => ({
  width: '20px',
  height: '20px',
  marginRight: '4px',
}))

export const StyledBenefitContainer = clubbiStyled('div')({
  textAlign: 'center',
  marginBottom: '10px',
})

export const StyledBenefitItem = clubbiStyled('div')(({ theme }) => ({
  marginBottom: '8px',
  color: theme.palette.brandWhite.main,
  fontSize: '16px',
  fontWeight: 600,
  '&:last-child': {
    marginBottom: 0,
  },
}))

export const StyledButton = clubbiStyled('button')(({ theme }) => ({
  width: '70%',
  fontWeight: '700',
  padding: '8px',
  borderRadius: '8px',
  border: 'none',
  cursor: 'pointer',

  backgroundColor: theme.palette.brandWhite.main,
  color: theme.palette.brandPurple[60],
  fontSize: theme.typography.fontSizeS,

  '&:hover': {
    opacity: 0.9,
  },
}))

export const StyledLink = clubbiStyled('a')(({ theme }) => ({
  fontSize: theme.typography.fontSize2XS,
  fontWeight: '500',
  textDecoration: 'none',
  cursor: 'pointer',

  color: theme.palette.brandPurple.main,

  '&: hover': {
    color: theme.palette.brandPurple.main,
  },
}))

export const StyledCloseButton = clubbiStyled('button')(({ theme }) => ({
  textDecoration: 'underline',
  border: 'none',
  position: 'absolute',
  right: '10px',
  top: '10px',

  color: theme.palette.brandWhite.main,
  backgroundColor: 'transparent',
}))

export const StyledCloseIcon = clubbiStyled(CloseIcon)(() => ({
  width: '20px',
}))
